module.exports = __webpack_public_path__ + "static/media/verticalTrackCardMiddleImage.736c9cb1.svg";